<template>
  <div :class="itemClass">
    <a href="#" @click="addRemove">
      <img :src="rootPath + teacher.img" :alt="teacher.longtitle" />
      <h5 class="has-text-black">
        <strong>{{ teacher.name }}</strong>
      </h5>
      <div class="is-overlay">
        <zoom-x-transition
          ><span class="selected" v-if="inList"
            >&check;</span
          ></zoom-x-transition
        >
      </div>
    </a>
  </div>
</template>

<script>
import { ZoomXTransition } from "vue2-transitions";
export default {
  components: {
    ZoomXTransition
  },
  data(){
    return {
      check: false,
    }
  },
  props: {
    teacher: Object
  },
  computed: {
    rootPath() {
      return `${process.env.VUE_APP_ROOT_PATH}`;
    },
    inList() {
      return this.$store.state.teacherSort.includes(this.teacher.id);
    },
    itemClass() {
      if (this.inList) {
        return "column is-2 teacher-item is-relative teacher-selected";
      }
      return "column is-2 teacher-item is-relative";
    }
  },
  methods: {
    addRemove() {
      if (!this.inList) {
        this.$store.dispatch("addTeacher", this.teacher.id);
      } else {
        this.$store.dispatch("removeTeacher", this.teacher.id);
      }
    }
  }
};
</script>

<style lang="scss">
.teacher-item {
  transition: all 0.3s ease;
  border: 2px solid transparent;
  text-align: center;
  h5 {
    font-size: 1.1rem;
    text-align: center;
  }

  span {
    display: none;
  }
  &:hover {
    border-color: hsl(141, 71%, 48%);
  }
}
.teacher-selected {
  border-color: hsl(141, 71%, 48%);
  span {
    display: inline-block;
    font-size: 4rem;
    color: hsl(141, 71%, 48%);
  }
  .is-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
